export const PAGE_STARTRUN_INITIALIZE = 'PAGE_STARTRUN_INITIALIZE';
export const PAGE_STARTRUN_ONCHANGEVALUE = 'PAGE_STARTRUN_ONCHANGEVALUE';
export const PAGE_STARTRUN_ONSAVE_REQUEST = 'PAGE_STARTRUN_ONSAVE_REQUEST';
export const PAGE_STARTRUN_ONSAVE_SUCCESS = 'PAGE_STARTRUN_ONSAVE_SUCCESS';
export const PAGE_STARTRUN_PROCESS_RECEIVE = 'PAGE_STARTRUN_PROCESS_RECEIVE';
export const PAGE_STARTRUN_USERS_RECEIVE = 'PAGE_STARTRUN_USERS_RECEIVE';
export const PAGE_STARTRUN_ONSAVE_ERROR = 'PAGE_STARTRUN_ONSAVE_ERROR';
export const PAGE_STARTRUN_ONFILEUPLOAD_REQUEST =
  'PAGE_STARTRUN_ONFILEUPLOAD_REQUEST';
export const PAGE_STARTRUN_ONFILEUPLOAD_RECEIVE =
  'PAGE_STARTRUN_ONFILEUPLOAD_RECEIVE';
export const PAGE_STARTRUN_ONFILEUPLOAD_ERROR =
  'PAGE_STARTRUN_ONFILEUPLOAD_ERROR';

export function initialize(defaultRunOwner) {
  return {
    type: PAGE_STARTRUN_INITIALIZE,
    defaultRunOwner
  };
}

export function receiveProcess(process) {
  return {
    type: PAGE_STARTRUN_PROCESS_RECEIVE,
    process
  };
}

export function receiveUsers() {
  return {
    type: PAGE_STARTRUN_USERS_RECEIVE
  };
}

export function valueChange(name, value) {
  return {
    type: PAGE_STARTRUN_ONCHANGEVALUE,
    name,
    value
  };
}

export function saveFormRequest(params) {
  return {
    type: PAGE_STARTRUN_ONSAVE_REQUEST,
    params
  };
}

export function saveFormResponse(response) {
  return {
    type: PAGE_STARTRUN_ONSAVE_SUCCESS,
    response
  };
}

export function saveFormError() {
  return {
    type: PAGE_STARTRUN_ONSAVE_ERROR,
    error: arguments
  };
}

export function fileUploadRequest() {
  return {
    type: PAGE_STARTRUN_ONFILEUPLOAD_REQUEST
  };
}

export function fileUploadReceive() {
  return {
    type: PAGE_STARTRUN_ONFILEUPLOAD_RECEIVE
  };
}

export function fileUploadError() {
  return {
    type: PAGE_STARTRUN_ONFILEUPLOAD_ERROR
  };
}



// WEBPACK FOOTER //
// ./js/actions/page/StartRun.js